<template>
    <div class="ku-home"></div>
</template>

<script>
// @ is an alias to /src

import {getCookie, setCookie} from "@/utils/auth"
import router from "@/router";

export default {
    name: 'home',
    data() {
        return {
            lat: '',
            lng: '',
            address: ''
        }
    },
    mounted() {
        let coType = getCookie('coType')
        let shopId = getCookie('shopId')
        if (coType === '2' || coType === '1') {
            setCookie('key_check', 1)
            router.push('/location')
        } else if (coType === '3') {
            router.push('/place_order?shopId=' + shopId)
        }
    },
    methods: {}
}
</script>

<style lang="less" scoped>
.ku-home {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #50AFA7;
}
</style>
